import { render } from "./App.vue?vue&type=template&id=319c39c8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=319c39c8&lang=css"

import exportComponent from "C:\\enjoy\\proyectos\\latam\\bitbucket\\web-enrolamiento-latam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__